import McAfee from './McAfee';
export default McAfee;
